import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;
  padding: 10px 2px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`

export const Progress = styled.div`
  position: absolute;
  left: 0;
  top: 10px;
  height: 4px;
  width: 50px;
  padding: 0 2px;
  background: ${({ theme }) => theme.colors.common.regular.brightBlue};
  z-index: 1;
`

export const Track = styled.div`
  height: 4px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.disabled};
  box-sizing: border-box;
  /*-webkit-appearance: slider-horizontal;*/
`

export const Handle = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  z-index: 2;
  width: 30px;
  height: 30px;
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  -ms-flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  transform: translate3d(-50%, -50%, 0);
  background: transparent;
`

export const Thumb = styled.div`
  border-radius: 50%;
  width: 22px;
  height: 22px;
  background-color: ${({ theme }) => theme.colors.background.white};
  border: 1px solid ${({ theme }) => theme.colors.common.regular.brightBlue};
  cursor: pointer; /* fallback if grab cursor is unsupported */
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: grab;
  /*-webkit-appearance: sliderthumb-horizontal;*/
`

export const Labels = styled.div`
  position: absolute;
  width: 100%;
  top: 24px;
  left: 0;
  padding: 0 4px;
  box-sizing: border-box;
  color: #90a0b2;
  font-size: 11px;

  [data-label='left'] {
    display: inline-block;
    width: 50%;
    text-align: left;
  }

  [data-label='right'] {
    display: inline-block;
    width: 50%;
    text-align: right;
  }
`
